<template>
    <div>
        <!--Modal de informações-->
        <vuestic-modal :show.sync="modal.show" ref="smallModal" v-bind:small="false" :cancelClass="'none'"
                       okText="Fechar" cancelText="Fechar">
            <div slot="title">Informações</div>

            <div v-show="modal.load">
                <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                    <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                        <component
                                :animation-duration="1000"
                                :is="'SpringSpinner'"
                                :color="'#4AE387'"
                                :size="80"
                        >
                        </component>
                    </div>
                </div>
            </div>
            <div v-show="!modal.load">
                <vuestic-tabs :names="['Dados Básicos','Endereço','Anexos']" ref="tabs">
                    <div slot="Dados Básicos">
                        <div class="row">
                            <div class="col-md-4">
                                <strong class="font-weight-bold">Nome:</strong><br>
                                {{modal.conteudo.nome}}
                            </div>
                            <div class="col-md-4">
                                <strong class="font-weight-bold">E-mail:</strong><br>
                                {{modal.conteudo.email}}
                            </div>
                            <div class="col-md-3">
                                <strong class="font-weight-bold">CPF:</strong><br>
                                {{modal.conteudo.cpf}}
                            </div>
                            <br><br><br>
                            <div class="col-md-4">
                                <strong class="font-weight-bold">Data de nascimento:</strong><br>
                                {{utils.formatDate(modal.conteudo.data_nascimento, true)}}
                            </div>
                            <div class="col-md-3">
                                <strong class="font-weight-bold">Telefone/Celular:</strong><br>
                                {{modal.conteudo.telefone}}
                            </div>
                        </div>
                    </div>
                    <div v-if="modal.conteudo.endereco_aluno" slot="Endereço">
                        <div class="row">
                            <div class="col-md-3">
                                <strong class="font-weight-bold">UF:</strong><br>
                                {{modal.conteudo.endereco_aluno.endereco.uf}}
                            </div>
                            <div class="col-md-6">
                                <strong class="font-weight-bold">Cidade:</strong><br>
                                {{modal.conteudo.endereco_aluno.endereco.cidade}}
                            </div>
                            <div class="col-md-3">
                                <strong class="font-weight-bold">CEP:</strong><br>
                                {{modal.conteudo.endereco_aluno.endereco.cep}}
                            </div>
                            <br><br><br>
                            <div class="col-md-6">
                                <strong class="font-weight-bold">Logradouro:</strong><br>
                                {{modal.conteudo.endereco_aluno.endereco.logradouro}}
                            </div>
                            <div class="col-md-3">
                                <strong class="font-weight-bold">Número:</strong><br>
                                {{modal.conteudo.endereco_aluno.numero}}
                            </div>
                            <div class="col-md-3">
                                <strong class="font-weight-bold">Complemento:</strong><br>
                                {{modal.conteudo.endereco_aluno.complemento}}
                            </div>
                        </div>
                        <br>
                    </div>
                    <div slot="Anexos">
                        <div class="row">
                            <div class="col-md-12" v-for="documentos in modal.conteudo.documentos" :key="documentos.tipos_documentos.constante_tipo_documento_matricula">

                              <span class="circle badge-success"></span>&nbsp;
                              <strong class="font-weight-bold">{{documentos.tipos_documentos.tipo_documento_matricula}}</strong>&nbsp;
                              <a target="_blank" rel="noopener noreferrer"
                              :href="'/public/alunos/'+modal.conteudo.id_aluno+'/documentos/'+documentos.documento.documento">Ver documento</a><br>
                              <!--<span>{{documentos.documento.documento_completo}}</span>-->

                            </div>
                        </div>
                    </div>
                </vuestic-tabs>
            </div>
        </vuestic-modal>
        <!--Botões da paginação-->

        <!--Legenda com barra de pesquisa-->
        <div class="row justify-content-end">
            <div class="col-md-3">
                <fieldset>
                    <div class="form-group with-icon-left">
                        <div class="input-group">
                            <input @input="debounceInput" id="search" autocomplete="off" required>
                            <label class="control-label" for="search">Procurar...</label><i class="bar"></i>
                            <i class="fa icon-left input-icon fa-search"></i>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <!--Legenda com barra de pesquisa-->
        <!--Botões da paginação-->
        <div class="row">
          <div class="col mx-auto">
            <nav>
              <ul class="pagination justify-content-center">
                <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                  <a class="page-link" href="#" tabindex="-1">Anterior</a>
                </li>
                <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                  <a class="page-link" href="#" tabindex="-1">Anterior</a>
                </li>                                      
                <template v-for="(page, index) in table.pages">
                  <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                    <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                  </li>
                  <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                    <a class="page-link"  href="#" >{{ page }}</a>
                  </li>
                </template>            
                <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                  <a class="page-link" href="#" tabindex="-1">Próximo</a>
                </li>
                <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                  <a class="page-link" href="#" tabindex="-1">Próximo</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <!--Botões da paginação-->
        <!--Tabela-->
        <div class="row">
            <div class="col-md-12">
                <table class="table table-responsive-sm">
                    <thead>
                    <tr>
                        <th v-for="th in tableOptions.thead" scope="col" :key="th.id">{{th}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-show="table.load">
                        <td colspan="6" class="text-center">
                            <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
                                <div class="btn-toolbar  d-inline-flex" role="toolbar"
                                     aria-label="Toolbar with button groups">
                                    <component
                                            :animation-duration="1000"
                                            :is="'SpringSpinner'"
                                            :color="'#4AE387'"
                                            :size="80"
                                    >
                                    </component>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-show="!table.load" v-for="dados in table.data" class="tb-linha" :key="dados.id_aluno">
                        <td>
                            <input type="checkbox" :name="'aluno_'+dados.id_aluno" :id="dados.cpf" :value="dados.id_aluno">
                        </td>
                        <td>{{ dados.nome }}</td>
                        <td>{{ dados.email }}</td>
                        <td>{{ dados.cpf }}</td>
                        <td>{{ dados.telefone }}</td>
                        <td>
                            <button title="Ver informações do aluno"
                                    class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                                    @click="detalhes(dados.id_aluno)"><span aria-hidden="true" class="fa fa-info"
                                                                                style="font-size: 16px;"></span>
                            </button>

                        </td>
                    </tr>
                    <tr v-show="table.data.length === 0 && !table.load">
                        <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!--Botões da paginação-->
        <div class="row">
          <div class="col mx-auto">
            <nav>
              <ul class="pagination justify-content-center">
                <li class="page-item disabled" id="previous_page" v-show="table.currentPage == 1">
                  <a class="page-link" href="#" tabindex="-1">Anterior</a>
                </li>
                <li class="page-item" id="previous_page" @click.stop="previousPage()" v-show="table.currentPage != 1">
                  <a class="page-link" href="#" tabindex="-1">Anterior</a>
                </li>                                      
                <template v-for="(page, index) in table.pages">
                  <li class="page-item" v-show="page !== table.currentPage" @click="page === table.currentPage ? null : pagePaginate(page)" :key="index + page + 'age'"> 
                    <a class="page-link" @click.prevent="page === table.currentPage ? null : pagePaginate(page)" href="#" >{{ page }}</a>
                  </li>
                  <li class="page-item active" v-show="page === table.currentPage"  :key="index"> 
                    <a class="page-link"  href="#" >{{ page }}</a>
                  </li>
                </template>            
                <li class="page-item disabled" id="previous_page" v-show="table.lastPage == table.currentPage">
                  <a class="page-link" href="#" tabindex="-1">Próximo</a>
                </li>
                <li class="page-item" id="previous_page" @click.stop="nextPage()" v-show="table.lastPage != table.currentPage">              
                  <a class="page-link" href="#" tabindex="-1">Próximo</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <!--Botões da paginação-->
        <!--Tabela-->
    </div>
</template>

<script>
import AlunosController from '../alunos/AlunosController'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import InputCheckboxGroup from '@/vuestic-theme/vuestic-components/vuestic-input/InputCheckboxGroup'
import utils from '../../services/utils'
import _ from 'lodash'

window._ = require('lodash')

export default {
  name: 'TableAlunos',
  components: {
    ...spinners,
    InputCheckboxGroup
  },
  data () {
    return {
      modal: {
        show: false,
        load: false,
        conteudo: {}
      },
      url: urlApi + '/alunos/paginacao/etapas/2',
      tableOptions: { 'thead': ['#', 'Nome', 'Email', 'CPF', 'Telefone', '-'] },
      search: '',
      table: {
        currentPage: '',
        data: '',
        firstPageUrl: '',
        from: '',
        lastPage: '',
        lastPageUrl: '',
        nextPageUrl: '',
        path: '',
        perPage: '',
        prevPageUrl: '',
        to: '',
        total: '',
        pages: [],
        load: true
      },
      utils: utils,
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    callbackDataPaginate (response) {
      console.log(response)
      let responseData = response.data
      this.table.currentPage = responseData.current_page
      this.table.data = responseData.data
      this.table.firstPageUrl = responseData.first_page_url
      this.table.from = responseData.from
      this.table.lastPage = responseData.last_page
      this.table.lastPageUrl = responseData.last_page_url
      this.table.nextPageUrl = responseData.next_page_url
      this.table.path = responseData.path
      this.table.perPage = responseData.per_page
      this.table.prevPageUrl = responseData.prev_page_url
      this.table.to = responseData.to
      this.table.total = responseData.total

      this.table.pages = []
      for (let i = 1; i <= (responseData.last_page); i++) {
        this.table.pages.push(i)
      }
      this.items = this.table.data

      this.table.load = false;

    },
    nextPage () {
      this.table.load = true      
      this.$http.get(this.table.nextPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
    },
    previousPage () {
      this.table.load = true
      this.$http.get(this.table.prevPageUrl + '&search=' + this.search ).then(this.callbackDataPaginate)
    },
    loadData () {
      this.table.load = true
      this.$http.get(this.url + '?search=' + this.search).then(this.callbackDataPaginate)
    },
    pagePaginate (page) {
      this.table.load = true
      this.$http.get(this.url + '?search=' + this.search + '&page=' + page).then(this.callbackDataPaginate)
    },
    debounceInput: _.debounce(function (e) {
      this.search = e.target.value
      this.loadData()
    }, 1000),
    detalhes: function (idAluno) {
      let self = this
      this.$refs.smallModal.open()
      self.modal.load = true
      AlunosController.getAlunoById(idAluno, function (response) {
        self.modal.conteudo = response.data.dados
        self.modal.load = false
        console.log(self.modal.conteudo)
      })
    },

    atualizaStatus: function (idAluno, status) {
      let self = this
      AlunosController.atualizaStatus(idAluno, status, function () {
        self.loadData()
      })
    },

    paginaEdicao (idAluno) {
      AlunosController.paginaEdicao(idAluno)
    },
    posicao(index){
      let distancia = index - this.table.currentPage;
      console.log(distancia);
      if(distancia > -3 && distancia < 1){
        return true;
      }
      return false;
    },
  }
}
</script>

<style type="text/css" scoped>
    .tb-opcoes {
        display: block;
        position: absolute;
        right: 20px;
        margin-top: -8px;
    }

    .tb-linha:hover .tb-opcoes {
        display: block;
    }

    @media (max-width: 1200px) {
        .tb-opcoes {
            display: block;
        }
    }

    .circle {
        width: .75rem;
        height: .75rem;
        border-radius: 50%;
        display: inline-block;
    }
</style>
